import type { AxiosInstance } from "axios";
import {
  doDeleteOrganizationIcon,
  doUploadOrganizationIcon,
  type U3148Organization,
} from "../../../U3148Service";
import type { U3148OrganizationIconPendingState } from "./u3148OrganizationIconPending";
import { hasOrganizationIconPendingChanges } from "./u3148OrganizationIconPending";

function extractOrganizationFromResponse(response: { data?: { result?: U3148Organization } & U3148Organization }) {
  return (response.data?.result ?? response.data) as U3148Organization | undefined;
}

/**
 * Applique upload/suppression icône en attente après save organisation réussi.
 * Le fichier remplace une suppression marquée (priorité upload).
 */
export async function flushPendingOrganizationIconChanges(
  axios: AxiosInstance,
  organizationId: string,
  pending: U3148OrganizationIconPendingState
): Promise<U3148Organization | null> {
  if (!hasOrganizationIconPendingChanges(pending)) {
    return null;
  }

  if (pending.pendingFile) {
    const formData = new FormData();
    formData.append("file", pending.pendingFile);
    const response = await doUploadOrganizationIcon(axios, organizationId, formData);
    return extractOrganizationFromResponse(response) ?? null;
  }

  if (pending.pendingDelete) {
    const response = await doDeleteOrganizationIcon(axios, organizationId);
    return extractOrganizationFromResponse(response) ?? null;
  }

  return null;
}
